module.exports = __webpack_public_path__ + "static/Images-1-009c3f8e754ac7e4e99c95be0f50fd61.png";